module.exports = __webpack_public_path__ + "static/assets/085c5eb3b205117750cc64925b74a284.png";